import { Component, OnInit, ViewChild } from '@angular/core';
import { ApexAxisChartSeries, ApexChart, ApexDataLabels, ApexFill, ApexMarkers, ApexPlotOptions, ApexStates, ApexTitleSubtitle, ApexTooltip, ApexXAxis, ApexYAxis, ChartComponent } from 'ng-apexcharts';
import { Cluster } from '../shared/Cluster.service';
import { HttpRequest } from '../shared/HttpRequest.service';

export type ChartOption = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  title: ApexTitleSubtitle;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  tooltip: ApexTooltip;
  dataLabels: ApexDataLabels;
  fill: ApexFill;
  markers: ApexMarkers;
  plotOptions: ApexPlotOptions;
  states: ApexStates;
}

@Component({
  selector: 'app-sidebar',
  animations: [],
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements OnInit {

  @ViewChild('chart', { static: false }) chart!: ChartComponent;
  public chartOptions!: Partial<ChartOption>;

  mexList: string[] = [];


  onHoverData: Boolean = false;

  tipoTerreno: string = '';
  urlImmagine: string = '';
  isImageCloudy: boolean = false;
  isImageNotFound: boolean = false;

  onImgError(event: Event) {
    this.isImageNotFound = true;
  }

  onImgLoad(event: Event) {
    const img = event.target as HTMLImageElement;
    if (!img.naturalWidth || !img.naturalHeight) {
      this.isImageNotFound = true;
    }
  }

  getHoverFirstImage() {
    return this.clusterService.hoverFirstImage;
  }


  dataPointPrec: number = -1;

  cropName: string = '';

  constructor(private clusterService: Cluster, private httpRequest: HttpRequest) { }

  ngOnInit(): void {
    this.mexList = this.clusterService.getMexList();
    this.initializeChartOption();

    this.clusterService.changeDataEvent
      .subscribe(
        (value: any) => {
          this.cropName = this.clusterService.currentCropName;
          const keys: string[] = value?.new_key    ?? value?.keys   ?? [];
          const vals: number[] = value?.new_values ?? value?.values ?? [];
          const isReset = keys.length === 0;

          console.log(`[Sidebar] evento=${isReset ? 'RESET' : 'DATA'} | chart=${this.chart ? 'OK' : 'NULL'} | vals[0]=`, isReset ? '-' : vals[0]);

          if (!this.chart) {
            console.warn('[Sidebar] chart ViewChild è NULL — fallback initializeChartOption');
            this.initializeChartOption();
            return;
          }

          if (!isReset) {
            this.chart.updateOptions({
              xaxis: { categories: keys },
              series: [{ name: 'NDVI', data: vals, color: '#4ade80' }]
            }, false, true);
            console.log('[Sidebar] updateOptions chiamato con', vals.length, 'valori');
          } else {
            this.chart.updateSeries([{ name: 'NDVI', data: [], color: '#4ade80' }], false);
          }
        }
      );

    // this.clusterService.changeSidebarMessages
    //   .subscribe(
    //     (value: string[]) => {
    //       this.changeMessages(value[0], value[1]);
    //     }
    //   );
  }

  changeMarkerColor() {
    // this.markers.discrete = [{
    //   seriesIndex: 0,
    //   dataPointIndex: 7,
    //   fillColor: '#e3e3e3',
    //   strokeColor: '#fff',
    //   size: 10
    // }]
  }

  // changeMessages(terreno: string, immagine: string) {
  //   // FUNZIONE PER FARE LA RICHIESTA HTTP
  //   this.tipoTerreno = terreno;
  //   this.urlImmagine = immagine;

  //   // this.httpRequest.getUrl(1).subscribe((url) => {
  //   //   this.urlImmagine = url;
  //   // })
  // }

  buttonMessage(): string {
    return this.clusterService.getClusterMexWithoutValue();
  }

  changeCluster(value: number) {
    this.clusterService.changeCluster(value);
    this.clusterService.changeClusterEvent.emit(value);
  }

  getMessage(index: number) {
    return this.clusterService.commentArray[index];
  }



  context = this;
  private initializeChartOption() {
    var context = this;
    this.chartOptions = {
      title: {
        text: 'NDVI nel tempo',
        style: {
          color: '#94a3b8',
          fontFamily: 'Inter, system-ui, sans-serif',
          fontSize: '11px',
          fontWeight: '600'
        }
      },
      series: [{
        name: 'NDVI',
        data: this.clusterService.values,
        color: '#4ade80'
      }],
      chart: {
        type: 'line',
        height: 180,
        animations: {
          speed: 600,
          easing: 'easeinout'
        },
        background: 'transparent',
        toolbar: { show: false },
        sparkline: { enabled: false },
        events: {
          mouseMove: function (event, chartContext, config) {
            if (config.dataPointIndex != -1 && config.dataPointIndex != context.dataPointPrec) {
              context.clusterService.hoverFirstImage = true;
              context.clusterService.changeHoverValue(config.dataPointIndex);
              const rawUrl = context.clusterService.urlArray[config.dataPointIndex];
              context.urlImmagine = (rawUrl && rawUrl !== 'null' && rawUrl !== 'undefined') ? rawUrl : '';
              context.isImageCloudy = context.clusterService.cloudyArray[config.dataPointIndex] ?? false;
              context.isImageNotFound = false;
              context.clusterService.changeHoverValueEvent.emit(config.dataPointIndex);
            }
            context.dataPointPrec = config.dataPointIndex;
          },
          dataPointMouseEnter: function (event, chartContext, config) {
            context.onHoverData = true;
          },
          dataPointMouseLeave: function (event, chartContext, config) {
            context.onHoverData = false;
          },
        },
        selection: { enabled: false }
      },
      xaxis: {
        tickAmount: 3,
        tickPlacement: 'between',
        categories: this.clusterService.keys,
        labels: {
          rotate: 0,
          style: {
            colors: Array(12).fill('#64748b'),
            fontFamily: 'Inter, sans-serif',
            fontSize: '9px'
          }
        },
        axisBorder: { color: 'rgba(255,255,255,0.08)' },
        axisTicks: { color: 'rgba(255,255,255,0.08)' }
      },
      yaxis: {
        tickAmount: 4,
        floating: false,
        decimalsInFloat: 2,
        labels: {
          style: {
            colors: ['#64748b'],
            fontFamily: 'Inter, sans-serif',
            fontSize: '9px'
          }
        },
        max: 1,
        min: 0
      },
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'dark',
          gradientToColors: ['#22c55e'],
          shadeIntensity: 1,
          type: 'horizontal',
          opacityFrom: 1,
          opacityTo: 1
        }
      },
      tooltip: {
        theme: 'dark',
        shared: false,
        intersect: true,
        style: {
          fontFamily: 'Inter, sans-serif',
          fontSize: '11px'
        },
        y: {
          formatter: function (value) {
            return value.toFixed(3);
          }
        }
      },
      markers: {
        size: 4,
        colors: ['#4ade80'],
        strokeColors: 'rgba(13,17,28,0.8)',
        strokeWidth: 2,
        hover: { size: 6 }
      },
      plotOptions: {
        bar: {
          dataLabels: { position: 'top' }
        }
      },
      states: {
        hover: {
          filter: { type: 'none' }
        }
      }
    }
  }
}
